import store from "../store";
const prefix = "/";

export default [
  {
    path: `${prefix}chamados`,
    meta: { auth: true, public: false },
    title: "Chamados",
    name: "Requests",
    component: () => import(`../views/request/private/RequestList.vue`),
  },
  {
    path: `${prefix}configuracoes`,
    meta: { auth: true, public: false },
    title: "Configurações dos Chamados",
    name: "RequestsConfigurations",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/request/private/RequestsConfigurations.vue`
      ),
  },
  {
    path: `${prefix}chamados/importar`,
    meta: { auth: true, public: false },
    title: "Importação dos Chamados",
    name: "RequestsImport",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/request/private/RequestsImport.vue`
      ),
  },
  {
    path: `${prefix}chamados/:id`,
    meta: { auth: true, public: false },
    title: "Editar Chamados",
    name: "RequestForm",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/request/private/RequestForm.vue`
      ),
  },
  {
    path: `${prefix}associar-responsaveis`,
    meta: { auth: true, public: false },
    title: "Responsáveis",
    name: "AssociateResponsibleList",
    component: () =>
      import(`../views/request/private/AssociateResponsibleList.vue`),
  },
  {
    path: `${prefix}unidades`,
    meta: { auth: true, public: false },
    title: "Unidades",
    name: "LocationsList",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/request/private/LocationsList.vue`
      ),
  },

  {
    path: "/canal-denuncias",
    meta: { auth: false, public: true },
    title: "Canal de Denuncias",
    name: "PublicRequest",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/request/PublicRequest.vue`
      ),
  },

  {
    path: `${prefix}departamentos`,
    meta: { auth: true, public: false },
    title: "Departamentos",
    name: "DepartmentIndex",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Department/index.vue`
      ),
  },

  {
    path: `${prefix}subcategorias`,
    meta: { auth: true, public: false },
    title: "Subcategorias",
    name: "Subcategory",
    component: () => import(`../views/request/private/RequestsSubcategory.vue`),
  },

  {
    path: `${prefix}substatus`,
    meta: { auth: true, public: false },
    title: "Substatus",
    name: "Substatus",
    component: () => import(`../views/request/private/RequestsSubstatus.vue`),
  },

  {
    path: `${prefix}tipos`,
    meta: { auth: true, public: false },
    title: "Tipos",
    name: "Types",
    component: () => import(`../views/request/private/RequestsTypes.vue`),
  },

  {
    path: `${prefix}configurar-logins`,
    meta: { auth: true, public: false },
    title: "Configuração de Logins",
    name: "CompanyLoginsList",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/company-logins/CompanyLoginsList.vue`
      ),
  },

  {
    path: prefix + "manuais",
    meta: { auth: true, public: false },
    title: "ManualView",
    name: "ManualView",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/manuals/Categories.vue`
      ),
  },
  {
    path: prefix + "treinamentos",
    meta: { auth: true, public: false },
    title: "CourseIndex",
    name: "CourseIndex",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/course/CourseIndex.vue`
      ),
  },
  {
    path: "/treinamentos/relatorios",
    meta: { auth: true, public: false },
    title: "CourseReport",
    name: "CourseReport",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/course/CourseReport.vue`
      ),
  },
  {
    path: "/treinamentos/onboarding",
    meta: { auth: true, public: false },
    title: "Onboarding",
    name: "OnboardingIndex",
    component: () => import(`@/views/course/CourseIndex.vue`),
  },
  {
    path: "/treinamentos/:id/conclusions-import",
    meta: { auth: true, public: false },
    title: "Import de Conclusões de Treinamento",
    name: "CourseConclusionsImport",
    component: () => import(`@/views/course/CourseConclusionsImport.vue`),
  },
  {
    path: prefix + "grupos",
    meta: { auth: true, public: false },
    title: "GroupIndex",
    name: "GroupIndex",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/DocumentGroup/index.vue`
      ),
  },
  {
    path: prefix + "manuais/:id",
    meta: { auth: true, public: false },
    title: "ManualCatetoryView",
    name: "ManualCatetoryView",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/manuals/Index.vue`
      ),
  },
  {
    path: prefix + "manuais/:slug/read",
    meta: { auth: true, public: false },
    title: "ManualRead",
    name: "ManualRead",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/manuals/ManualView.vue`
      ),
  },

  {
    path: `${prefix}todas-atividades`,
    meta: { auth: true, public: false },
    title: "Todas Atividades",
    name: "AllActivities",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/activities/allActivities/index.vue`
      ),
  },
  {
    path: `${prefix}atividades`,
    meta: { auth: true, public: false },
    title: "Minhas Atividades",
    name: "Activities",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/activities/RequestsActivities.vue`
      ),
  },
  {
    path: `${prefix}preset-messages`,
    meta: { auth: true, public: false },
    title: "PresetMessages",
    name: "PresetMessages",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/request/private/PresetMessages.vue`
      ),
  },
  {
    path: "/403",
    meta: { auth: false, public: true },
    title: "Forbidden",
    name: "PublicForbidden",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/request/PublicForbidden.vue`
      ),
  },
];
